import React, {useRef, useState} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function CreateBlueRemarks(props) {
    const {t} = useTranslation();
    const name = useRef();
    const sortOrder = useRef();
    const description = useRef();
    const [disabled, setDisabled] = useState(0);
    const [isActive, setIsActive] = useState(true);

    const createBlueRemarksHandler = (e) => {
        e.preventDefault();
        setDisabled(1);
        axios.post(API_URL + "blue-remarks/create", {
            name: name.current.value,
            description: description.current.value,
            sort_order: sortOrder.current.value || 0,
            is_active: isActive,
        }).then((response) => {
            setDisabled(0);
            if (response.data.status) {
                alertify.success(response.data.message);
                props.history.push("/blue-remarks/list");
            } else {
                alertify.error(response.data.message);
            }
        }).catch(() => {
            setDisabled(0);
            alertify.error("Something went wrong. Try again!");
        });
    };

    return (
        <Row>
            <Col md={12}>
                <Card>
                    <CardHeader title={t("Add New Blue Remark")}>
                        <CardHeaderToolbar>
                            <Link to="/blue-remarks/list" className="btn btn-primary btn-sm mx-3">
                                {t("Blue Remarks List")}
                            </Link>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <div className="mt-5">
                            <Form onSubmit={createBlueRemarksHandler}>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Name")}</Form.Label>
                                        <Form.Control ref={name} placeholder={t("Enter Blue Remark Name")}/>
                                    </Form.Group>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Sort Order")}</Form.Label>
                                        <Form.Control ref={sortOrder} type="number" defaultValue={0}/>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Description")}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            ref={description}
                                            rows={5}
                                            placeholder={t("Enter Description")}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Check
                                            type="checkbox"
                                            id="is_active"
                                            label={t("Active")}
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                    {t("Save")}
                                    <span
                                        dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                </Button>
                            </Form>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}
